import React, { useState, useCallback } from "react";
import { Check, ChevronDown, X } from "react-feather";
import { FormattedDate, useIntl } from "react-intl";
import { formatPercent } from "./../../../utils/format";

const AreaCriteria = ({
  criteria,
  selectedCriteria,
  openCriteria,
  toggleCollapse
}) => {
  const [areaCollapsed, setAreaCollapsed] = useState(false);
  const { formatMessage } = useIntl();

  const hasAreaInfractions = useCallback(() => {
    if (!criteria) return false;
    return !!criteria.find(crit => !crit.conforme);
  }, [criteria]);

  return (
    <div className={`report-section${areaCollapsed ? " collapsed" : ""}`}>
      <h3 onClick={() => setAreaCollapsed(!areaCollapsed)}>
        <ChevronDown className="collapse-indicator" />{" "}
        {formatMessage({ id: "area" })}
        {hasAreaInfractions() ? (
          <X className="section-status-icon error" />
        ) : (
          <Check className="section-status-icon check" />
        )}
      </h3>

      {criteria.map(
        criterion =>
          selectedCriteria.includes(criterion.B3Criterio.id) && (
            <div
              className={`criteria-information${
                !openCriteria.includes(criterion.id) ? " collapsed" : ""
              }`}
              key={criterion.id}
            >
              <div
                className="criteria-title"
                onClick={() => toggleCollapse(criterion.id)}
              >
                <div className="text">
                  <div>
                    <ChevronDown size="18px" />
                  </div>
                  <div>{criterion.B3Criterio.nome}</div>
                </div>
                {criterion.status !== "processado" ? (
                  <div className="loader tiny"></div>
                ) : (
                  <div>
                    {!criterion.conforme ? (
                      <X className="error-icon" />
                    ) : (
                      <Check className="check-icon" />
                    )}
                  </div>
                )}
              </div>
              <div className="criteria-details">
                {criterion.B3Criterio.descricao && criterion.B3Criterio.slug !== 'supressao_vegetacao_nativa' ? (
                  <div>
                    <span className="bold">
                      {formatMessage({ id: "descricao" })}:{" "}
                    </span>
                    {criterion.B3Criterio.descricao}
                  </div>
                ) : (
                  <div>
                    <span className="bold">
                      {formatMessage({ id: "descricao" })}:{" "}
                    </span>
                    <span dangerouslySetInnerHTML={{ __html: criterion.B3Criterio.descricao }} />
                    
                  </div>
                )}
                {criterion.B3Criterio.fonte && (
                  <div>
                    <span className="bold">
                      {formatMessage({ id: "fonte" })}:{" "}
                    </span>
                    <a
                      href={criterion.B3Criterio.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {criterion.B3Criterio.fonte}
                    </a>
                  </div>
                )}
                {criterion.B3CriterioVersao && criterion.B3CriterioVersao.data && (
                  <div>
                    <span className="bold">
                      {formatMessage({ id: "data-base" })}:{" "}
                    </span>
                    <FormattedDate
                      value={new Date(criterion.B3CriterioVersao.data)}
                    />
                  </div>
                )}
                {criterion.detalhes_json &&
                  criterion.detalhes_json.data_consulta && (
                    <div>
                      <span className="bold">
                        {formatMessage({ id: "data-consulta" })}:{" "}
                      </span>
                      <FormattedDate
                        value={new Date(criterion.detalhes_json.data_consulta)}
                      />
                    </div>
                  )}
                {criterion.conforme ? (

                  <>
                    {criterion.B3Criterio.slug === 'identifica_car' && (
                      <div className="infraction">
                        <div className="infraction">
                          <span className="bold">
                            {formatMessage({ id: "infracoes-encontradas" })}:
                          </span>
                        </div>
                        
                        {criterion.descricao &&
                      criterion.descricao.map((infraction, index) => (
                        <div key={index} className="infraction">
                          {infraction.length > 0 && (
                            <div>
                              <div className="status-icon">
                                
                              </div>
                              <div>
                                <span className="bold">
                                  {infraction[0].nome}:{" "}
                                </span>
                                {infraction[0].valor}
                              </div>
                            </div>
                          )}
                          {infraction.length > 1 &&
                            infraction.slice(1).map(detail => (
                              <p key={detail.nome}>
                                <span className="bold">{detail.nome}: </span>
                                {detail.valor}
                              </p>
                            ))}
                        </div>
                      ))}
                      </div>
                    )} 
                    {criterion.B3Criterio.slug === 'status_imovel' && (
                      <div className="infraction">
                        <div className="infraction">
                          <span className="bold">
                            {formatMessage({ id: "item-conforme" })}:
                            Status&nbsp;
                            {criterion.detalhes_json && criterion.detalhes_json.status} 
                          </span>
                        </div>
                      </div>
                    )} 
                    {!['identifica_car', 'status_imovel'].includes(criterion.B3Criterio.slug) && (
                      <div className="infraction">
                        <div>
                          <div className="status-icon">
                            <Check className="check-icon" size="16px" />
                          </div>
                          <span className="bold">
                            {formatMessage({ id: "nenhuma-infracao" })}
                          </span>
                        </div>
                      </div>
                    )}
                  </>

                  
                ) : (
                  <>
                  {criterion.B3Criterio.slug === 'status_imovel' && (
                    <>
                      <div className="infraction">
                        <span className="bold">
                          {formatMessage({ id: "item-desconforme"})}:&nbsp;
                        </span>
                        Status&nbsp;
                        {criterion.detalhes_json && criterion.detalhes_json.status} 
                      </div>
                    </>
                  )}
                  {!['status_imovel'].includes(criterion.B3Criterio.slug) && (
                    <div>
                      <div className="infraction">
                        <span className="bold">
                          {formatMessage({ id: "porcentagem-sobreposicao" })}:{" "}
                        </span>

                        <span>
                          
                        { formatPercent( criterion.detalhes_json.porcentagem_decimal ) }
                        </span>

                      </div>

                      <div className="infraction">
                        <span className="bold">
                          {formatMessage({ id: "infracoes-encontradas" })}:
                        </span>
                      </div>
                      {criterion.descricao &&
                        criterion.descricao.map((infraction, index) => (
                          <div key={index} className="infraction">
                            {infraction.length > 0 && (
                              <div>
                                <div className="status-icon">
                                  <X className="error-icon" size="16px" />
                                </div>
                                <div>
                                  <span className="bold">
                                    {infraction[0].nome}:{" "}
                                  </span>
                                  {infraction[0].valor}
                                </div>
                              </div>
                            )}
                            {infraction.length > 1 &&
                              infraction.slice(1).map(detail => (
                                <p key={detail.nome}>
                                  <span className="bold">{detail.nome}: </span>
                                  {detail.valor}
                                </p>
                              ))}
                          </div>
                        ))}
                    </div>
                  )}
                  </>
                )}
              </div>
            </div>
          )
      )}
    </div>
  );
};

export default AreaCriteria;
